var _circle, _path, _path2, _path3, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIcSuggestion = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 96,
  height: 96,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  className: "dd-privacy-hidden"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 48,
  cy: 48,
  r: 48,
  fill: "#fff"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M25.09 48v13.684a4 4 0 0 0 2.159 3.551l18.91 9.81a4 4 0 0 0 3.683 0l18.91-9.81a4 4 0 0 0 2.157-3.55V48L50.302 58.69a5 5 0 0 1-4.604 0L25.09 48Z",
  fill: "#405B73"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "m18.848 35.116 27.31-14.161a4 4 0 0 1 3.683 0l27.31 14.16c2.879 1.493 2.879 5.61 0 7.103l-27.31 14.16a4 4 0 0 1-3.682 0l-27.31-14.16c-2.879-1.493-2.879-5.61 0-7.102Z",
  fill: "#405B73"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M46 40a2 2 0 0 1 2-2h30a4 4 0 0 1 4 4v14a2 2 0 1 1-4 0V42H48a2 2 0 0 1-2-2Z",
  fill: "#F4CC54"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 80,
  cy: 48,
  r: 4,
  fill: "#F4CC54"
})));
export default SvgIcSuggestion;